import { Action, ReducerTypes, ActionCreator, ActionReducer, createReducer } from '@ngrx/store';

export const createSessionRehydrateReducer = <S, A extends Action = Action>(
  key: string,
  initialState: S,
  ...ons: ReducerTypes<S, ActionCreator[]>[]
): ActionReducer<S, A> => {
  const item = sessionStorage.getItem(key);
  const newInitialState = (item && JSON.parse(item)) ?? initialState;
  const newOns: ReducerTypes<S, ActionCreator[]>[] = [];

  ons.forEach((oldOn: ReducerTypes<S, ActionCreator[]>) => {
    newOns.push({ ...oldOn, reducer: oldOn.reducer });

    const newReducer = (state: S, action: Action) => {
      const newState = oldOn.reducer(state as S, action);
      sessionStorage.setItem(key, JSON.stringify(newState));

      return newState;
    };

    newOns.push({ ...oldOn, reducer: newReducer });
  });

  return createReducer(newInitialState, ...newOns);
};